if (!customElements.get('approval-compare-summary')) {
    class ApprovalCompare extends HTMLElement {

        constructor() {
            super();

            this._loading = true;
            this.hasSummary = this.dataset.hasSummary == 'true';
            this.cartSummary = this.querySelector('#cart-summary');
            this.cartCompare = this.querySelector('#cart-compare');
            this.loader = this.querySelector('[data-loader]');
            this.compareGrid = this.querySelector('[data-grid]');
            this.lastLoaded = null;
        }

        set loading(value) {
            this._loading = value;

            if (value) {
                this.loader?.classList.remove('hidden');
                this.compareGrid?.classList.add('hidden');
            } else {
                this.loader?.classList.add('hidden');
                this.compareGrid?.classList.remove('hidden');
            }
        }

        get loading() {
            return this._loading;
        }

        connectedCallback() { }

        disconnectedCallback() { }

        async showCompare(item) {

            this.loading = true;

            let colIndex = 1;
            const { handle, variant_id, properties } = item;

            if (this.lastLoaded != variant_id) {
                // @ts-ignore
                this.compareGrid.innerHTML = '';
            }

            this.cartSummary?.classList.remove('selected');
            this.cartCompare?.classList.add('selected');

            if (this.lastLoaded == variant_id) {
                this.loading = false;
                return;
            }

            const relatedInformation = properties['_related_information'].split('#');
            const rows = relatedInformation.length + 1;

            const mainCompareProduct = await this.loadProduct(handle, variant_id, colIndex++, rows);
            // @ts-ignore
            this.compareGrid.innerHTML += mainCompareProduct;

            for await (const related of relatedInformation) {
                const row = related.split('|');
                const variantId = row[0];
                const handle = row[1];
                const mainCompareProduct = await this.loadProduct(handle, variantId, colIndex++, rows);
                // @ts-ignore
                this.compareGrid.innerHTML += mainCompareProduct;
            }

            this.compareGrid?.style.setProperty('--cols', colIndex);
            this.lastLoaded = variant_id;
            this.loading = false;
        }

        hideCompare(item) {
            this.loading = true;
            this.cartSummary?.classList.add('selected');
            this.cartCompare?.classList.remove('selected');
        }

        async loadProduct(handle, variantId, col, rows) {
            const mainProduct = await fetch(`/products/${handle}?variant=${variantId}&section_id=approval-product-compare`);
            const mainProductResponse = await mainProduct.text();
            const template = document.createElement('template');
            template.innerHTML = mainProductResponse
                .replaceAll('##COL##', `${col}`)
                .replaceAll('##ROWS##', `${rows}`);
            const compareElement = template.content.querySelector(`.shopify-section`);
            return compareElement?.innerHTML;
        }
    }

    customElements.define('approval-compare-summary', ApprovalCompare);
}

